module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "42px",
      "height": "42px",
      "viewBox": "0 0 42 42",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('filter', {
    attrs: {
      "id": "a",
      "x": "-61.5%",
      "y": "-61.5%",
      "width": "223.1%",
      "height": "223.1%"
    }
  }, [_c('feOffset', {
    attrs: {
      "dx": "0",
      "dy": "0",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter1"
    }
  }), _c('feGaussianBlur', {
    attrs: {
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1",
      "stdDeviation": "4"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "in": "shadowBlurOuter1",
      "result": "shadowMatrixOuter1",
      "type": "matrix",
      "values": "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.297831075 0"
    }
  }), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter1"
    }
  }), _c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1)], 1), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "filter": "url(#a)",
      "transform": _vm.arrowIcon
    }
  }, [_c('circle', {
    attrs: {
      "cx": "13",
      "cy": "13",
      "fill": "#fff",
      "r": "11.5",
      "stroke": _vm.color,
      "stroke-width": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "m16 9v8h-3v-5.001l-5 .001v-3z",
      "fill": _vm.color,
      "transform": "matrix(.70710678 .70710678 -.70710678 .70710678 12.707107 -4.67767)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c4ccbb","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/slider/images/components/CardSliderArrowSvg.vue
// module id = 636e427115dba542ef03
// module chunks = 0